import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';

interface MissingHintProps {
    missing: string[];
}

export function MissingHint({ missing }: MissingHintProps) {
    if (missing.length === 0) return null;
    return (
        <Tooltip content={`Missing: ${missing.join(', ')}`} focusable>
            <span className="inline-flex items-center gap-1 text-[11px] font-medium text-yellow-700 bg-yellow-50 border border-yellow-200 rounded-full h-5 px-1.5 whitespace-nowrap">
                <ExclamationTriangleIcon className="h-3 w-3" />
                Incomplete
            </span>
        </Tooltip>
    );
}
